import io from "socket.io-client";
import router from "../routes/index.js";

let socket = null;

function connectWs(url, userId) {
  if (socket && socket.connected) {
    return; // 중복 연결 방지
  }

  if (socket) {
    // disconnected 상태의 잔존 인스턴스 정리
    disconnectWs();
  }

  const addr = url.replace(/\/?$/, "/") + "dupLogins";
  console.log("[socket] connect : ", addr);

  socket = io(addr, {
    path: "/ws/v1",
    transports: ["websocket"],
    upgrade: false,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000, // 재연결 지연 시간 (최초 대기 시간 1초)
    reconnectionDelayMax: 30000, // 최대 재연결 지연 시간 30초마다 시도
    randomizationFactor: 0, // 지수 백오프 및 랜덤 편차 제거 (고정 30초를 위해 필요)
  });

  socket.on("connect", () => {
    console.log("[socket] connected ", socket.connected);
  });

  socket.on("disconnect", () => {
    console.log("[socket] disconnect ", socket.disconnected);
  });

  socket.on("message", (data) => {
    console.log("[socket] message : ", data);
    if (!data || data.cmd == null) {
      return;
    }

    switch (data.cmd) {
      case 1:
        sendWsMessage({
          cmd: 100,
          userId: userId,
          d: "stv",
          deviceId: localStorage.getItem("deviceId"),
        });
        break;
      case 0:
        console.log("[socket] event : session expired");
        disconnectWs();
        router.replace({
          name: "expire",
          params: { t: new Date().getTime() },
        });
        break;
    }
  });

  function sendWsMessage(msg) {
    socket.emit("client", msg);
    console.log("[socket] client : ", msg);
  }
}

function disconnectWs() {
  if (socket) {
    console.log("[socket] disconnectWs");
    socket.off("connect");
    socket.off("disconnect");
    socket.off("message");
    socket.close();
    socket = null;
  }
}

export { connectWs, disconnectWs };
